<template>
  <v-app-bar fixed :color="colorTheme" clipped-left dark app>
    <img :src="imageLogo" style="height: 80%;" />
    <v-toolbar-title color="white" class="webTitle ml-3">NEUTRINO</v-toolbar-title>
    <v-spacer></v-spacer>
    <!-- <v-spacer></v-spacer> -->
    <v-badge
        :content="notiNumber"
        :value="notiNumber"
        color="red"
        v-if="this.$store.state.production == false"
        class="mr-3 "
    >
        <v-icon @click.stop="drawer()" class="icon-size">
          mdi-bell
        </v-icon>
    </v-badge>
      
    <v-divider
      class="mr-3"
      inset
      vertical
      v-if="$route.path == '/individualFuel' && visible == false"
    ></v-divider>

    <v-btn text @click="showCalendarFunction()" v-if="$route.path == '/individualFuel' && visible == false" class="icon-size" min-width="30" max-width="30">
      <v-icon left dark>mdi-calendar</v-icon>
    </v-btn>

    <v-divider
        class="mr-3"
        inset
        vertical
        v-if="showFilter"
    ></v-divider>
    <v-btn
        v-if="visible && showFilter"
        text
        :disabled="disableButton"
        style="height: 100% !important; margin: 0 !important;"
        v-on:click="bottomSheet()"
        small
    >
      <v-icon class="icon-size" left dark>mdi-car-cog</v-icon>
      <span class="regularText">
          {{
          $t("filterVehicles").toUpperCase()
          }}
      </span>
    </v-btn>
    <v-btn
        v-if="visible == false && showFilter"
        bottom left
        text
        :disabled="disableButton"
        style="height: 100% !important;"
        v-on:click="bottomSheet()"
        small
        min-width="30"
        max-width="30"
    >
      <v-icon class="icon-size" left dark>mdi-car-cog</v-icon>
    </v-btn>

    <!-- </div> -->

    <!--V if production when notifications function-->
    <v-badge v-if="false" v-model="show" color="red" overlap>
      <template v-slot:badge>
        <span>12</span>
      </template>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon text v-on="on">
            <v-icon large>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-list two-line subheader>
          <v-list-item v-for="(item, index) in items" :key="index" @click="logout()">
            <v-list-item-avatar :color="colorTheme">
              <v-icon color="#fff">{{ item.icon }}</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-btn text small :color="colorTheme" style="width: 100%;">VER MÁS</v-btn>
        </v-list>
      </v-menu>
    </v-badge>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "toolbar",
  components: {
    calendarTime: () => import("@/components/calendarTime")
  },
  data() {
    return {
      msg: "toolbar",
      userData: [],
      userName: "",
      items: [
        {
          icon: "warning",
          iconClass: "grey lighten-1 white--text",
          title: "Exceso de velocidad",
          subtitle: "PHX1-10001"
        },
        {
          icon: "trending_up",
          iconClass: "grey lighten-1 white--text",
          title: "Exceso de RPMs",
          subtitle: "PHX1-10003"
        },
        {
          icon: "record_voice_over",
          iconClass: "grey lighten-1 white--text",
          title: "Tiempo de manejo excedido",
          subtitle: "PHX1-10003"
        }
      ],
      show: true,
      pathsShowingTheFilter: ["/home","/dashboard", "/individualFuel", "/tracking", "/accountManager", "/reportsPage", "/settingsAT", "/vehiclesExceptions", "/accountBalancePage"],
      showFilter: false
    };
  },
  computed: {
    ...mapState([
      "imageLogo", 
      "colorTheme", 
      "disableButton", 
      "notiNumber",
      "visible"
    ])
  },
  created() {
    //se revisa si se muestra filtro cuando se crea el componente
    this.checkPathForFilter();
  },
  mounted() {
    this.setUser();
  },
  beforeUpdate () {
    //se revisa si se muestra filtro cuando hay breadcrumbs
    this.checkPathForFilter();
  },
  methods: {
    setUser() {
      this.userData = this.$store.state.userData;
      this.userName = this.userData.UserName;
    },
    logout() {},
    bottomSheet() {
      this.$store.commit("bottomSheet");
      var initialSettings = JSON.parse(localStorage.getItem("initialSettings"));
      if (!initialSettings) {
        var dID = localStorage.getItem("Dealer_Id");
        var cID = localStorage.getItem("Client_Id");
        var aID = localStorage.getItem("Account_Id");
        var gID = localStorage.getItem("Group_Id");
        var account = aID == "NA" || aID == "ND" ? "" : aID;
        var group = gID == "NA" || gID == "ND" ? "" : gID;
        if (this.$route.path == "/individualFuel") {
          this.$store.dispatch("getFuelVehicles");
        } else if (this.$route.path == "/dashboard" || this.$route.path == "/tracking") {
          this.$store.dispatch("getVehiclesCatalog", [
          "&did=" + dID + "&cid=" + cID + "&acid=" + account + "&gpid=" + group,
          true,
          false,
          ]);
        }
      }
    },
    showCalendarFunction() {
      this.$store.commit("calendarTime", true);
    },
    drawer() {
      this.$store.commit("manageNotiDrawer");
    },
    checkPathForFilter() {
      this.showFilter = this.pathsShowingTheFilter.indexOf(this.$route.path) > -1;
    }
  }
};
</script>

<style scoped>
</style>